import { useMutation } from '@tanstack/react-query';
import { sendSuggestionService } from '../../services/send-suggestions';

export const useSendSuggestion = () => {
  const mutation = useMutation({
    mutationFn: (message:string) => sendSuggestionService({ message }),
  });

  return mutation;
};
